import { IonText } from "@ionic/react";
import { Modal } from "@src/app/components/modal";
import { useState } from "react";

import { IShiftPayChangedModalProps } from "../model";

const ShiftPayChangedModal = ({
  isOpen,
  onDidDismiss,
  changedShiftPayText,
  onConfirm,
}: IShiftPayChangedModalProps) => {
  const [displayMode, setDisplayMode] = useState<"full" | "compact">("full");

  return (
    <Modal
      titleHtml={
        <span>
          <h1>Shift pay has been lowered!</h1>
        </span>
      }
      confirmText={"Continue"}
      cancelText={"Cancel"}
      isOpen={isOpen}
      onConfirm={onConfirm}
      onDismiss={onDidDismiss}
      onLayoutBodyContentScrollbarDetected={() => setDisplayMode("compact")}
      hideBunnyLogo={displayMode === "compact"}
    >
      <IonText class="ion-text-center ion-padding-horizontal ion-padding-top ">
        <span>
          The rate for this shift was adjusted recently, and it's lower than the rate you saw on
          your screen. Do you want to continue booking at the new rate of ${changedShiftPayText}?
        </span>
      </IonText>
    </Modal>
  );
};

export { ShiftPayChangedModal };
